import timetableRepo from '../services/timetables';

export const SHOW_NEW_TIMETABLE_OVERLAY    = 'SHOW_NEW_TIMETABLE_OVERLAY';
export const HIDE_NEW_TIMETABLE_OVERLAY    = 'HIDE_NEW_TIMETABLE_OVERLAY';
export const SHOW_DELETE_TIMETABLE_OVERLAY = 'SHOW_DELETE_TIMETABLE_OVERLAY';
export const HIDE_DELETE_TIMETABLE_OVERLAY = 'HIDE_DELETE_TIMETABLE_OVERLAY';
export const SHOW_EDIT_TIMETABLE_OVERLAY   = 'SHOW_EDIT_TIMETABLE_OVERLAY';
export const HIDE_EDIT_TIMETABLE_OVERLAY   = 'HIDE_EDIT_TIMETABLE_OVERLAY';
export const TIMETABLES_REFRESHED          = 'TIMETABLES_REFRESHED';

export function hideEditTimetableOverlay() {

    return {
        type: HIDE_EDIT_TIMETABLE_OVERLAY
    }
}

export function showEditTimetableOverlay(timetable) {

    return {
        type: SHOW_EDIT_TIMETABLE_OVERLAY,
        timetable
    }
}

export function deleteTimetable(timetableId) {
    
    return (dispatch) => {
        
        function removeSuccess() {
            
            dispatch(hideDeleteTimetableOverlay());
            dispatch(refreshTimetables());
        }
        
        timetableRepo.remove(timetableId)
            .then(removeSuccess);
    };
}

export function showDeleteTimetableOverlay(timetable) {

    return {
        type: SHOW_DELETE_TIMETABLE_OVERLAY,
        timetable
    };
}

export function hideDeleteTimetableOverlay() {

    return {
        type: HIDE_DELETE_TIMETABLE_OVERLAY
    };
}

export function refreshTimetables() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(timetablesRefreshed(response.data.data));
        }

        timetableRepo.getAll()
            .then(getSuccess);
    };
}

export function timetablesRefreshed(timetables) {

    return {
        type: TIMETABLES_REFRESHED,
        timetables
    };
}

export function hideNewTimetableOverlay() {

    return {
        type: HIDE_NEW_TIMETABLE_OVERLAY
    };
}

export function showNewTimetableOverlay() {

    return {
        type: SHOW_NEW_TIMETABLE_OVERLAY
    };
}


// WEBPACK FOOTER //
// ./actions/timetableList.js